import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { resolveImage } from "../lib/image";
import { fmt } from "../lib/money";

const STATUS_COLORS = {
  placed: "bg-[#0033FF] text-white",
  shipped: "bg-black text-white",
  delivered: "bg-[#00A355] text-white",
  cancelled: "bg-[#FF2A00] text-white",
};

export default function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">
      <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tight">My orders</h1>
      <div className="mt-10 border-t border-neutral-200">
        {orders.length === 0 && (
          <div className="py-20 text-center text-neutral-500">No orders yet.</div>
        )}
        {orders.map((o) => (
          <Link
            key={o.order_id}
            to={`/orders/${o.order_id}`}
            data-testid={`order-row-${o.order_id}`}
            className="grid grid-cols-[1fr_auto_auto_auto] gap-6 items-center py-6 border-b border-neutral-200 hover:bg-neutral-50 px-2 -mx-2"
          >
            <div>
              <div className="font-display font-bold text-lg">{o.items.length} item{o.items.length > 1 ? "s" : ""}</div>
              <div className="text-xs text-neutral-500 mt-1">
                {new Date(o.created_at).toLocaleDateString()} · #{o.order_id.slice(-8)}
              </div>
            </div>
            <div className="flex -space-x-3">
              {o.items.slice(0, 3).map((it) => (
                <div key={it.product_id} className="w-10 h-10 border border-neutral-200 bg-neutral-100 overflow-hidden">
                  {it.image && <img src={resolveImage(it.image)} alt="" className="w-full h-full object-cover" />}
                </div>
              ))}
            </div>
            <span className={`text-[10px] uppercase tracking-widest font-bold px-2 py-1 ${STATUS_COLORS[o.status]}`}>
              {o.status}
            </span>
            <span className="font-display font-black text-lg">{fmt(o.total)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
